<ng-container *transloco="let t; read:'permit.signature'">
    <div class="modal">
        <div class="modal__content">
            <pmt-permit-summary class="modal__content__summary" [permitId]="data.permitId" [forModal]="true"></pmt-permit-summary>

            <div class="modal__content__heading">
                {{ t("signature") }} <span class="modal__content__heading__roles" [innerHtml]="formattedRoles"></span>
            </div>

            <signature-pad *ngIf="signaturePadOptions" class="modal__content__signature" #signature [options]="signaturePadOptions"
                           (drawStart)="drawStart($event)" (drawEnd)="drawComplete($event)"></signature-pad>

            <div class="modal__content__details">
                <div class="modal__content__details__person">
                    <div class="modal__content__details__person__name">{{ data.name }}</div>
                </div>
                <button class="modal__content__details__clear-button" (click)="clear()">{{ t("clear") }}</button>
            </div>

            <div class="modal__content__details" *ngIf="data.person.concept === 2 && data.person.personalNumber === null && data.person.hasForeignPersonalNumber === false">
                <div class="modal__content__title">{{t("missingPersonalNumber")}}</div>
                <div class="modal__content__info-message">{{t("addressPersonalNumber")}}</div>
                <div class="modal__form__container">
                    <ha-input class="modal__form__field" type="personalNumber" [(ngModel)]="personalNumber" [label]="t('personalNumber')" (input)="personalNumberOnChange()"></ha-input>
                    <ha-checkbox class="modal__content--checkbox" [(ngModel)]="hasForeignPersonalNumber" [label]="t('noSwedishPnr')" (click)="hasForeignPersonalNumberClick()"></ha-checkbox>
                    <div *ngIf="(!isPersonalNumberValid)" class="modal__content__error-message">{{ t("invalidPnr") }}</div>
                </div>
            </div>
        </div>

        <div class="modal__actions">
            <button class="modal__actions__close" type="button" (click)="closeModal()">{{ t("cancel") }}</button>
            <button class="modal__actions__save" [class.modal__actions__save--disabled]="!isValid" type="button" (click)="save()">{{ t("save") }}</button>
        </div>
    </div>
</ng-container>
